import { lazy } from 'react';

export const LandingProductAsync = lazy(() => import('./landing-product'));
